import React, { useEffect, useState } from 'react';
import { Form, Button, Spinner, Alert, InputGroup } from 'react-bootstrap';
import ReactSelect from 'react-select';
import Creatable from 'react-select/creatable';
import './PaymentHistoryForm.css';
import FuncFetch from '../../Utilities/funcFetch';
import { useMsal } from '@azure/msal-react';
import useFetch from '../../Utilities/useFetch';

const PaymentHistoryForm = ({
    defaultFormData,
    projects,
    loadingProjects,
    readOnly,
    debtorID,
    updateAccountFieldsAndActivities
}) => {
    const [formData, setFormData] = useState({
        checkStatus: null,
        collection_Type: null,
        collector: null,
        dateReceived: null,
        dateRemitted: null,
        debtorID: debtorID,
        deposit_Date: null,
        fee_Date: null,
        fee_Rate: null,
        memo: null,
        payor: null,
        paymentAmount: null,
        paymentDate: null,
        paymentMethod: null,
        receiver: null,
        remit_Amount: null,
        remit_Check: null,
        remitCheckClear: false
    });
    const {data:collectors,loading:loadingCollectors} = useFetch(true,`${process.env.REACT_APP_API_URL}/Claims/GetCollectors`,'GET')

    const [checkStatusOptions] = useState([
        {value:"Account Closed",label:"Account Closed"},
        {value:"Current",label:"Current"},
        {value:"Decline",label:"Decline"},
        {value:"Do Not Remit",label:"Do Not Remit"},
        {value:"Failed",label:"Failed"},
        {value:"Hold",label:"Hold"},
        {value:"NSF",label:"NSF"},
        {value:"Posted",label:"Posted"},
        {value:"Refunded",label:"Refunded"},
        {value:"Returned",label:"Returned"},
        {value:"Stop-Pay",label:"Stop-Pay"},
        {value:"Void",label:"Void"}])
    const [paymentMethodOptions] = useState([
        { value: "Wire-Transfer", label: "Wire-Transfer" },
        { value: "Cashiers Check", label: "Cashiers Check" },
        { value: "Check", label: "Check" },
        { value: "DRAFT", label: "DRAFT" },
        { value: "Money-Order", label: "Money-Order" },
        { value: "EFT", label: "EFT" },
        { value: "Credit Card", label: "Credit Card" },
        { value: "ACH", label: "ACH" }
    ])
    const [recieverOptions] = useState([
        {value:"1",label:"1"},
        {value:"2",label:"2"}
    ])
    const [payorOptions] = useState([
        {value:"CLMT",label:"CLMT"},
        {value:"RO",label:"RO"},
        {value:"Other",label:"Other"},
        {value:"",label:""}
    ])
    const [payorInputValue, setPayorInputValue] = useState('');
    const [collectorOptions, setCollectorOptions] = useState();
    const [projectOptions, setProjectOptions] = useState();
    const {instance, accounts} = useMsal();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        if(collectors){
            setCollectorOptions(collectors.map(collector => { return { value: collector.key, label: collector.value } }));
        }
        if(projects){
            setProjectOptions(projects.map(project => { return { value: project.key, label: project.value } }));
        }
    }, [collectors, projects]);

    useEffect(() => {
        if (defaultFormData&&Object.keys(defaultFormData).length>0) {
            setFormData(defaultFormData);
            setPayorInputValue(defaultFormData.payor || '');
        }
    }, [defaultFormData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleReactSelectChange = (value, name) => {
        setFormData({
            ...formData,
            [name]: value
        });
    }

    const handleSubmit = (e) => {
        setLoading(true);
        setSuccess(false);
        setError(null);
        e.preventDefault();
    
        const requiredFields = [
            'paymentDate',
            'paymentAmount',
            'checkStatus',
            'paymentMethod',
            'receiver',
        ];
    
        const missingFields = requiredFields.filter(field => {
            return !formData[field]
        });
    
        if (missingFields.length > 0) {
            setError(`Missing required fields: ${missingFields.join(', ')}`);
            setLoading(false);
            return;
        }

        const resetForm = () => { 
            setFormData({
                checkStatus: null,
                collection_Type: null,
                collector: null,
                dateReceived: null,
                dateRemitted: null,
                debtorID: debtorID,
                deposit_Date: null,
                fee_Date: null,
                fee_Rate: null,
                memo: null,
                payor: null,
                paymentAmount: null,
                paymentDate: null,
                paymentMethod: null,
                receiver: null,
                remit_Amount: null,
                remit_Check: null,
                remitCheckClear: false
            });
            setPayorInputValue('');
            document.getElementById("payment-form").reset();
         }
    
        FuncFetch(`${process.env.REACT_APP_API_URL}/Claims/PostPayment`, null, 'POST', formData, instance, accounts)
            .then(response => {
                resetForm()
                response.paymentHistory.unshift({});
                updateAccountFieldsAndActivities(response);
                setLoading(false);
                setSuccess(true);
            })
            .catch(error => {
                setLoading(false);
                setError('There was an issue, please try again');
                console.error(error);
            });
    };

    const filterOption = (option, inputValue) => {
        if(option.label){
            return option.label.toLowerCase().startsWith(inputValue.toLowerCase());
        }else{
            return false
        }
      };

    return (
        <Form className='payment-form' id='payment-form' onSubmit={handleSubmit} >
            <Form.Group controlId="paymentDate">
                <Form.Label>Payment Date<span className='required-field'>*</span></Form.Label>
                <InputGroup>
                    <Form.Control
                        className='payment-form-input'
                        type="date"
                        name="paymentDate"
                        value={formData.paymentDate?formData.paymentDate.split('T')[0]:''}
                        onChange={handleChange}
                        disabled={readOnly}
                        max={new Date().toISOString().split('T')[0]}
                        menuPosition="fixed"
                    />
                    <Button variant="outline-secondary" onClick={() => handleReactSelectChange(null, 'paymentDate')} disabled={readOnly}>×</Button>
                </InputGroup>
            </Form.Group>

            <Form.Group controlId="paymentAmount">
                <Form.Label>Payment Amount<span className='required-field'>*</span></Form.Label>
                <InputGroup>
                    <Form.Control
                        className='payment-form-input'
                        type="number"
                        step="any"
                        name="paymentAmount"
                        value={formData.paymentAmount}
                        onChange={handleChange}
                        disabled={readOnly}
                    />
                    <Button variant="outline-secondary" onClick={() => handleReactSelectChange(null, 'paymentAmount')} disabled={readOnly}>×</Button>
                </InputGroup>
            </Form.Group>

            <Form.Group controlId="checkStatus">
                <Form.Label>Check Status<span className='required-field'>*</span></Form.Label>
                <ReactSelect
                    className='payment-form-input'
                    as="select"
                    name="checkStatus"
                    value={formData.checkStatus?checkStatusOptions.find(checkStatus=>checkStatus.value===formData.checkStatus):null}
                    onChange={(e)=>handleReactSelectChange(e?e.value:null,'checkStatus')}
                    isClearable
                    isDisabled={readOnly}
                    options={checkStatusOptions}
                    filterOption={filterOption}
                    menuPosition="fixed"
                />
            </Form.Group>

            <Form.Group controlId="paymentMethod">
                <Form.Label>Payment Method<span className='required-field'>*</span></Form.Label>
                <ReactSelect
                    className='payment-form-input'
                    as="select"
                    name="paymentMethod"
                    value={formData.paymentMethod?paymentMethodOptions.find(paymentMethod=>paymentMethod.value===formData.paymentMethod):null}
                    onChange={(e)=>handleReactSelectChange(e?e.value:null,'paymentMethod')}
                    isClearable
                    isDisabled={readOnly}
                    options={paymentMethodOptions}
                    filterOption={filterOption}
                    menuPosition="fixed"
                />
            </Form.Group>

            <Form.Group controlId="receiver">
                <Form.Label>Receiver<span className='required-field'>*</span></Form.Label>
                <ReactSelect
                    className='payment-form-input'
                    as="select"
                    name="receiver"
                    value={(recieverOptions&&formData.receiver)?recieverOptions.find(reciever=>reciever.value===formData.receiver):null}
                    onChange={(e)=>handleReactSelectChange(e?e.value:null,'receiver')}
                    isClearable
                    isDisabled={readOnly}
                    options={recieverOptions}
                    filterOption={filterOption}
                    menuPosition="fixed"
                />
            </Form.Group>

            <Form.Group controlId="dateReceived">
                <Form.Label>Date Received</Form.Label>
                <InputGroup>
                    <Form.Control
                        className='payment-form-input'
                        type="date"
                        name="dateReceived"
                        value={formData.dateReceived?formData.dateReceived.split('T')[0]:''}
                        onChange={handleChange}
                        disabled={readOnly}
                        max={new Date().toISOString().split('T')[0]}
                        menuPosition="fixed"
                    />
                    <Button variant="outline-secondary" onClick={() => handleReactSelectChange(null, 'dateReceived')} disabled={readOnly}>×</Button>
                </InputGroup>
            </Form.Group>

            <Form.Group controlId="dateRemitted">
                <Form.Label>Date Remitted</Form.Label>
                <InputGroup>
                    <Form.Control
                        className='payment-form-input'
                        type="date"
                        name="dateRemitted"
                        value={formData.dateRemitted?formData.dateRemitted.split('T')[0]:''}
                        onChange={handleChange}
                        disabled={readOnly}
                        max={new Date().toISOString().split('T')[0]}
                        menuPosition="fixed"
                    />
                    <Button variant="outline-secondary" onClick={() => handleReactSelectChange(null, 'dateRemitted')} disabled={readOnly}>×</Button>
                </InputGroup>
            </Form.Group>

            <Form.Group controlId="remit_Check">
                <Form.Label>Remit Check</Form.Label>
                <InputGroup>
                    <Form.Control
                        className='payment-form-input'
                        type="text"
                        name="remit_Check"
                        value={formData.remit_Check}
                        onChange={handleChange}
                        disabled={readOnly}
                    />
                    <Button variant="outline-secondary" onClick={() => handleReactSelectChange(null, 'remit_Check')} disabled={readOnly}>×</Button>
                </InputGroup>
            </Form.Group>

            <Form.Group controlId="remitCheckClear">
                <Form.Label>Remit Check Clear<span className='required-field'>*</span></Form.Label>
                <Form.Check
                    className='payment-form-input big-checkbox'
                    type="checkbox"
                    name="remitCheckClear"
                    checked={formData.remitCheckClear}
                    onChange={(e) => handleChange({ target: { name: 'remitCheckClear', value: e.target.checked } })}
                    disabled={readOnly}
                    menuPosition="fixed"
                />
            </Form.Group>

            <Form.Group controlId="memo">
                <Form.Label>Memo</Form.Label>
                <InputGroup>
                    <Form.Control
                        className='payment-form-input'
                        type="text"
                        name="memo"
                        value={formData.memo}
                        onChange={handleChange}
                        disabled={readOnly}
                    />
                    <Button variant="outline-secondary" onClick={() => handleReactSelectChange(null, 'memo')} disabled={readOnly}>×</Button>
                </InputGroup>
            </Form.Group>

            <Form.Group controlId="collector">
                <Form.Label>Collector</Form.Label>
                {loadingCollectors ?
                    <Spinner animation="border" role="status" />
                    : (collectors&&collectorOptions) ?
                        <ReactSelect
                            className='payment-form-input'
                            value={formData.collector?collectorOptions.find(collector=>collector.value.toLowerCase()===formData.collector.toLowerCase()):null}
                            onChange={(e)=>handleReactSelectChange(e?e.value:null,'collector')}
                            isClearable
                            options={collectorOptions}
                            isDisabled={readOnly}
                            filterOption={filterOption}
                            menuPosition="fixed"
                        />
                        : null}
            </Form.Group>

            <Form.Group controlId="deposit_Date">
                <Form.Label>Deposit Date</Form.Label>
                <InputGroup>
                    <Form.Control
                        className='payment-form-input'
                        type="date"
                        name="deposit_Date"
                        value={formData.deposit_Date?formData.deposit_Date.split('T')[0]:''}
                        onChange={handleChange}
                        max={new Date().toISOString().split('T')[0]}
                        disabled={readOnly}
                        menuPosition="fixed"
                    />
                    <Button variant="outline-secondary" onClick={() => handleReactSelectChange(null, 'deposit_Date')} disabled={readOnly}>×</Button>
                </InputGroup>
            </Form.Group>

            <Form.Group controlId="payor">
                <Form.Label>Payor</Form.Label>
                <Creatable
                    className='payment-form-input'
                    name="payor"
                    value={formData.payor?{value:formData.payor,label:formData.payor}:null}
                    inputValue={formData.payor ? '' : payorInputValue}
                    onChange={(e)=>{
                        handleReactSelectChange(e?e.value:null,'payor');
                        setPayorInputValue('');
                    }}
                    onCreateOption={(inputValue)=>{
                        handleReactSelectChange(inputValue,'payor');
                        setPayorInputValue('');
                    }}
                    onInputChange={(inputValue, actionMeta)=>{
                        if(actionMeta.action === 'input-change'){
                            setPayorInputValue(inputValue);
                        }
                    }}
                    onBlur={()=>{
                        if(!formData.payor && payorInputValue.trim()){
                            handleReactSelectChange(payorInputValue.trim(),'payor');
                            setPayorInputValue('');
                        }
                    }}
                    isClearable
                    isDisabled={readOnly}
                    options={payorOptions}
                    filterOption={filterOption}
                    menuPosition="fixed"
                    
                />
            </Form.Group>

            <Form.Group controlId="fee_Rate">
                <Form.Label>Fee Rate</Form.Label>
                <InputGroup>
                    <Form.Control
                        className='payment-form-input'
                        type="number"
                        name="fee_Rate"
                        step="any"
                        value={formData.fee_Rate}
                        onChange={handleChange}
                        disabled={readOnly}
                    />
                    <Button variant="outline-secondary" onClick={() => handleReactSelectChange(null, 'fee_Rate')} disabled={readOnly}>×</Button>
                </InputGroup>
            </Form.Group>

            <Form.Group controlId="fee_Date">
                <Form.Label>Fee Date</Form.Label>
                <InputGroup>
                    <Form.Control
                        className='payment-form-input'
                        type="date"
                        name="fee_Date"
                        value={formData.fee_Date?formData.fee_Date.split('T')[0]:''}
                        onChange={handleChange}
                        max={new Date().toISOString().split('T')[0]}
                        disabled={readOnly}
                        menuPosition="fixed"
                    />
                    <Button variant="outline-secondary" onClick={() => handleReactSelectChange(null, 'fee_Date')} disabled={readOnly}>×</Button>
                </InputGroup>
            </Form.Group>

            <Form.Group controlId="remit_Amount">
                <Form.Label>Remit Amount</Form.Label>
                <InputGroup>
                    <Form.Control
                        className='payment-form-input'
                        type="number"
                        step="any"
                        name="remit_Amount"
                        value={formData.remit_Amount}
                        onChange={handleChange}
                        disabled={readOnly}
                    />
                    <Button variant="outline-secondary" onClick={() => handleReactSelectChange(null, 'remit_Amount')} disabled={readOnly}>×</Button>
                </InputGroup>
            </Form.Group>

            <Form.Group controlId="collection_Type">
                <Form.Label>Collection Type</Form.Label>
                {loadingProjects ?
                    <Spinner animation="border" role="status" />
                    : projects ?
                        <ReactSelect
                            className='payment-form-input'
                            value={formData.collection_Type?projectOptions.find(project=>project.value===formData.collection_Type):null}
                            onChange={(e)=>handleReactSelectChange(e?e.value:null,'collection_Type')}
                            isClearable
                            options={projectOptions}
                            isDisabled={readOnly}
                            filterOption={filterOption}
                            menuPosition="fixed"
                        />
                        : null}
            </Form.Group>
            {error?
            <Alert variant="danger">{error}</Alert>
            :success?
            <Alert variant="success">Success</Alert>
            :null}
            {!readOnly&&
            loading?
            <Spinner animation="border" role="status" />
            :
            <Button variant="primary" type="submit" disabled={readOnly}>
                Submit
            </Button>
            }
        </Form>
    );
};

export default PaymentHistoryForm;